/**
 * Contact page: modal, form validation, captcha refresh, submit.
 * Expects global jQuery ($) from layout.
 */
(function () {
  const $ = (window as Window & { jQuery?: (sel: string | Element) => any }).jQuery;
  if (!$) return;

  const $modal = $("#no-modal");
  const $desc = $("#no-modal-desc");
  const $ok = $modal.find("[data-modal-ok]");
  let onClose: (() => void) | null = null;

  function openModal( message: string, cb?: () => void ) {
    onClose = typeof cb === "function" ? cb : null;
    $desc.text( message || "" );
    $modal.addClass( "is-open" ).attr( "aria-hidden", "false" );
    $( "body" ).addClass( "is-lock" );
    setTimeout( () => {
      ( $ok[0] as HTMLElement )?.focus();
    }, 0 );
  }

  function closeModal() {
    $modal.removeClass( "is-open" ).attr( "aria-hidden", "true" );
    $( "body" ).removeClass( "is-lock" );
    const cb = onClose;
    onClose = null;
    if ( cb ) cb();
  }

  $modal.on("click", "[data-modal-close]", function () {
    closeModal();
  });
  $ok.on("click", function () {
    closeModal();
  });

  $(document).on("keydown", function (e: JQueryEventObject) {
    if ( !$modal.hasClass( "is-open" ) ) return;
    if ( e.key === "Escape" || e.key === "Enter" ) closeModal();
  } );

  ( window as Window & { noModal?: { open: typeof openModal; close: typeof closeModal } } ).noModal = {
    open: openModal,
    close: closeModal,
  };

  function refreshCaptcha() {
    const captchaImg = document.getElementById( "captcha-img" );
    if ( !captchaImg ) return;
    const form = document.getElementById( "frm" );
    const baseUrl =
      ( form && form.getAttribute( "data-captcha-url" ) ) || ( captchaImg as HTMLImageElement ).src.split( "?" )[0];
    ( captchaImg as HTMLImageElement ).src =
      baseUrl + ( baseUrl.indexOf( "?" ) >= 0 ? "&" : "?" ) + "t=" + Date.now();
  }

  $( document ).on( "click", "#captcha-refresh", function () {
    refreshCaptcha();
  } );

  function syncFilledState() {
    $( "#frm" )
      .find( "input[type=\"text\"], textarea" )
      .each( function ( this: HTMLInputElement | HTMLTextAreaElement ) {
        $( this )
          .closest( "li" )
          .toggleClass( "is-filled", ( this.value || "" ).trim() !== "" );
      } );
  }

  function syncCheckboxState() {
    $( ".check-box" ).toggleClass( "active", ( $( "#check" )[0] as HTMLInputElement )?.checked === true );
  }

  function fitTextarea() {
    const ta = document.getElementById( "contents" ) as HTMLTextAreaElement | null;
    if ( !ta ) return;
    ta.style.height = "auto";
    ta.style.height = ta.scrollHeight + "px";
  }

  $( function () {
    syncFilledState();
    syncCheckboxState();
    fitTextarea();

    $( "#frm" ).on( "input change", "input[type=\"text\"], textarea", function () {
      syncFilledState();
    } );

    $( "#check" ).on( "change", function () {
      syncCheckboxState();
    } );

    $( "#contents" ).on( "input", function () {
      fitTextarea();
    } );

    $( window ).on( "resize", function () {
      fitTextarea();
    } );

    $( "#frm" ).on( "submit", function ( e ) {
      e.preventDefault();
      ( window as Window & { doRequest?: () => void } ).doRequest?.();
    } );
  } );

  ( window as Window & { doRequest?: () => void } ).doRequest = function () {
    const $frm = $( "#frm" );
    const form = $frm[0] as HTMLFormElement;
    if ( !form ) return;

    function m(msg: string, $focusEl?: any) {
      openModal(msg, function () {
        if ($focusEl && $focusEl.length) ($focusEl[0] as HTMLElement)?.focus();
      });
    }

    const name = ( $( "#name" ).val() as string || "" ).trim();
    const email = ( $( "#email" ).val() as string || "" ).trim();
    const contents = ( $( "#contents" ).val() as string || "" ).trim();
    const captcha = ( $( "#r_captcha" ).val() as string || "" ).trim();
    const agreed = ( $( "#check" )[0] as HTMLInputElement )?.checked === true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!name) return m("Please enter your name.", $("#name"));
    if (!email) return m("Please enter your email.", $("#email"));
    if (!emailRegex.test(email)) return m("Please enter a valid email address.", $("#email"));
    if (!contents) return m("Please enter your message.", $("#contents"));
    if (!agreed) return m("Please agree to the collection and use of personal information.", $("#check"));
    if (!captcha) return m("Please enter the security code.", $("#r_captcha"));

    const data = new FormData( form );
    const submitUrl = form.getAttribute( "data-submit-url" ) || form.action || "/contact";

    $.ajax( {
      type: "POST",
      url: submitUrl,
      data,
      processData: false,
      contentType: false,
      cache: false,
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      success(res: string | { success?: boolean; result?: string; message?: string; msg?: string }) {
        let jsonData: { success?: boolean; result?: string; message?: string; msg?: string };
        try {
          jsonData = typeof res === "string" ? JSON.parse(res) : res;
        } catch {
          return m("처리 중 오류가 발생했습니다.");
        }
        const ok = jsonData.success === true || jsonData.result === "success";
        const msg = jsonData.message || jsonData.msg || "";
        if (!ok) return m(msg || "처리 중 오류가 발생했습니다.");
        openModal(msg || "접수되었습니다.", () => location.reload());
      },
      error(xhr: { responseText?: string }) {
        let msg = "서버 통신 중 오류가 발생했습니다.";
        if ( xhr.responseText ) {
          try {
            const err = JSON.parse( xhr.responseText ) as { message?: string; msg?: string };
            msg = err.message || err.msg || msg;
          } catch {
            /* ignore */
          }
        }
        m(msg);
      },
    });
  };
})();

interface JQueryEventObject {
  key?: string;
}
